import TemplateView from '../TemplateView'
import messageResource from '../messageResource'
import {createTokensHighlighterForSearch} from '../util/TokensHighlighter'
import {defer} from '../atUtils'


export default class SearchItemList extends TemplateView {
    constructor({
        itemRenderer = (item, tokensHighlighter) => {},
        additionalItemRenderer = (item) => {},
        notFoundMessageKey = '',
        hiddenItemsCollapsedMessageKey = '',
        hiddenItemsExpandedMessageKey = '',
    }) {
        super()

        this.props = {
            itemRenderer,
            additionalItemRenderer,
            notFoundMessageKey,
            hiddenItemsCollapsedMessageKey,
            hiddenItemsExpandedMessageKey,
        }

        this.state = {
            items: [],
            hiddenItems: [],
            additionalItems: [],
            searchText: '',
            hiddenItemsCollapsed: true,
            selectedItemId: -1,
        }

        this.onAnyStatePropertyDeeplyChanged(['items', 'additionalItems', 'hiddenItems',
                                              'searchText', 'hiddenItemsCollapsed', 'selectedItemId'], () => {
            this._renderList(this.state.items, this.state.hiddenItems, this.state.additionalItems, this.state.searchText)
        })

    }

    templateHtml() {
        return '<div class="searchItemList">' +
               '</div>'
    }

    _renderList(items, hiddenItems, additionalItems, searchText) {
        this.getEl().empty()

        let tokensHighlighter = createTokensHighlighterForSearch(searchText)

        let renderedItems = []

        if (!this.state.searchText) {
            renderedItems.push(...additionalItems.map(i => this.props.additionalItemRenderer(i)))
        }

        if ((items.length + renderedItems.length === 0) && (this.state.hiddenItemsCollapsed || hiddenItems.length === 0)) {
            renderedItems.push(this._createNoItemsFound())
        }

        renderedItems.push(...items.map(i => this.props.itemRenderer(i, tokensHighlighter)))

        if (hiddenItems.length > 0) {
            renderedItems.push(this._createHiddenItemsButton(hiddenItems.length, this.state.hiddenItemsCollapsed))

            if (!this.state.hiddenItemsCollapsed) {
                renderedItems.push(...hiddenItems.map(i => this.props.itemRenderer(i, tokensHighlighter)))
            }
        }

        renderedItems.forEach(item => item.init(this.getEl()))
    }

    _createNoItemsFound() {
        return new ItemRow({
            name: messageResource.getMessage(this.props.notFoundMessageKey),
            additionalClass: 'notFound',
        })
    }

    _createHiddenItemsButton(hiddenItemsNum, collapsed) {
        return new ItemRow({
            name: messageResource.getEscapedMessage(collapsed ?
                                                       this.props.hiddenItemsCollapsedMessageKey :
                                                       this.props.hiddenItemsExpandedMessageKey, [hiddenItemsNum]),
            clickCallback: () => {
                defer(() => this.setState({
                    hiddenItemsCollapsed: !collapsed
                }), this)
            },
            mousedownCallback: (event) => event.preventDefault(),
            additionalClass: 'collapseHiddenButton',
        })
    }
}

export class ItemRow extends TemplateView {
    constructor({
        name = '',
        clickCallback = () => {},
        mousedownCallback = (e) => {},
        additionalClass = '',
    }) {
        super()

        this.params = {
            name,
            clickCallback,
            mousedownCallback,
            additionalClass,
        }
    }

    templateHtml() {
        return '<div class="itemRow <%-additionalClass%>"><%=name%></div>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            name: this.params.name,
        }
    }

    afterRender() {
        this.$el.click(() => this.params.clickCallback())
        this.$el.mousedown((e) => this.params.mousedownCallback(e))
    }
}



// WEBPACK FOOTER //
// ./web/js/components/SearchItemList.js